export const ADD_MERCHANTS = 'ADD_MERCHANTS';

export const ADD_SINGLE_MERCHANT = 'ADD_SINGLE_MERCHANT';
